import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CommonModal from "./CommonModal";
import Style from "./modal.module.scss";
import "react-phone-input-2/lib/style.css";
import {
  auPhNumber,
  auText,
  identityText,
  mail,
  nzPhNumber,
  nzText,
  orSmall,
  ph,
  buttonName
} from "../../locales/en";
import {
  MAILTO_INFO_EMAIL,
  PHONE_NO_AU,
  PHONE_NO_NZ
} from "../../utils/constants/appConstants";

const OnboardingIdentityInfoModal = ({ isOpen, toggle }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title=" "
      modalClassName={`${Style.xeroModal} ${Style.manualUploadModal} modal-lg modal-dialog-centered`}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0`}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: toggle
        }
      ]}
    >
      <div className="inv-upload-template flex-sm-wrap-reverse">
        <div className={`${Style.manul_Invoice_Submit}`}>
          <p>{identityText?.onboardingIntInfogModal.inOrder}</p>
          <p>{identityText?.onboardingIntInfogModal.pleaseConact}</p>
          <p>
            {identityText?.onboardingIntInfogModal.fundTap}

            <span className="d-block">
              {`${identityText?.onboardingIntInfogModal.email} `}
              <Link to={MAILTO_INFO_EMAIL}>{mail}</Link>
            </span>

            <span className="d-block">
              {ph} {auText} <Link to={PHONE_NO_AU}>{auPhNumber}</Link>
              {` ${orSmall} `} {`${nzText} `}
              <Link to={PHONE_NO_NZ}>{nzPhNumber}</Link>
            </span>
          </p>
        </div>
      </div>
    </CommonModal>
  );
};

OnboardingIdentityInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default OnboardingIdentityInfoModal;
